// extracted by mini-css-extract-plugin
module.exports = {"section":"WorkspaceManagerTable_section__2FHQh","container":"WorkspaceManagerTable_container__3WcDc"};